import { render, staticRenderFns } from "./webSetting.vue?vue&type=template&id=63600fa1&scoped=true&"
import script from "./webSetting.vue?vue&type=script&lang=js&"
export * from "./webSetting.vue?vue&type=script&lang=js&"
import style0 from "./webSetting.vue?vue&type=style&index=0&id=63600fa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63600fa1",
  null
  
)

export default component.exports